import React from "react";
import { SignoutCallbackComponent } from "redux-oidc";
import userManager from "../../utils/oidcUserManager";
import { useDispatch } from "react-redux";
import * as actions from "../../modules/Auth/_redux/authActions";

function SignoutCallbackPage() {

    const dispatch = useDispatch();
    const redirectToIdentityProvider = () => {
        dispatch(actions.logout());
        userManager.signinRedirect().catch(console.error);
    };

    return (
        <SignoutCallbackComponent
            userManager={userManager}
            successCallback={redirectToIdentityProvider}
            errorCallback={error => {
                console.error(error);
                redirectToIdentityProvider();
            }}
        >
            <div>Redirecting...</div>
        </SignoutCallbackComponent>
    );
}

export default SignoutCallbackPage;
